import http from './http'
import util from "../store/utils";
class ExternalApi {
    static externalAuthUser(params) {
        return http.httpPost('external/authUser',params).then(res => {
            console.log(res,'返回的是大发');
            if(res.newCommer){
                return res;
            }else{
                let authorization = 'Bearer ' + res.accessToken;
                util.runAuth('set', authorization, 12, 'h');
                window.localStorage.user = JSON.stringify(res.user);
                return res.user;
            }

        });
    }
}
export default ExternalApi;



// WEBPACK FOOTER //
// ./app/api/external.api.js